import { render, staticRenderFns } from "./BaseRedpack.vue?vue&type=template&id=82755c00&scoped=true&"
import script from "./BaseRedpack.vue?vue&type=script&lang=js&"
export * from "./BaseRedpack.vue?vue&type=script&lang=js&"
import style0 from "./BaseRedpack.vue?vue&type=style&index=0&id=82755c00&prod&lang=scss&scoped=true&"
import style1 from "./BaseRedpack.vue?vue&type=style&index=1&id=82755c00&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82755c00",
  null
  
)

export default component.exports